import React from 'react';
import { Box, Dialog, DialogActions, DialogContent, Slide, Typography } from '@mui/material';
import { UserRole } from '@uplift/types';
import { Button } from '../../Button';
import { useCurrentuser } from '@uplift/contexts';


export const MessagingNotice: React.FC = () => {
  const me = useCurrentuser();

  return (
    <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', maxWidth: '94%' }} data-testid="messaging-notice">
        {me.role === UserRole.patient && (
          <>
            <Typography variant="body1" align="center" color="textPrimary" textAlign="justify" sx={{ mt: 4 }}>
              Your provider will check their inbox when they login to BetterHelp. If you are experiencing an urgent or emergent mental health crisis, please call <strong>888-380-2028</strong>, press <strong>1</strong> to be connected to our 24/7 call center. For questions around claims or billing, email us at <strong>help@joinuplift.co</strong>.
            </Typography>
            <Typography variant="body1" align="center" color="textPrimary" textAlign="justify" sx={{ mt: 4 }}>
              Please Note: BetterHelp is not an emergency service. If you&apos;re experiencing a medical emergency, please contact <strong>911</strong> immediately or go to your nearest emergency room. If you are experiencing a mental health crisis or have thoughts of suicide, or not wanting to live, please call the National Suicide Prevention Lifeline at <strong>988</strong>. They have a national network of crisis centers that provide free and confidential emotional support 24 hours a day / 7 days a week.
              You can also use the 24/7 Crisis Text Line by texting &quot;HOME&quot; to <strong>741-741</strong>.
            </Typography>
            <Typography variant="body1" align="center" color="textPrimary" textAlign="justify" sx={{ mt: 4 }}>
              All communications with your individual provider outside of a session must occur within this messaging tool. You are responsible for checking your messages regularly.
            </Typography>
            <Typography variant="body1" align="center" color="textPrimary" textAlign="justify" sx={{ mt: 4 }}>
              This messaging tool is not intended for and should not be used for therapeutic, treatment, or care purposes.
            </Typography>
          </>
        )}
        {me.role === UserRole.provider && (
          <>
            <Typography variant="body1" align="center" color="textPrimary" textAlign="justify" sx={{ mt: 4 }}>
              All patient communications outside of a session must occur within this messaging tool, unless there is an extenuating circumstance. You are responsible for checking your messages regularly.
            </Typography>
            <Typography variant="body1" align="center" color="textPrimary" textAlign="justify" sx={{ mt: 4 }}>
              This messaging tool is not intended for and should not be used for therapeutic, treatment, or care purposes.
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};


export const MessagingNoticeModal: React.FC = () => {
  const [ open, setOpen ] = React.useState(true);

  return (
    <Dialog open={open} fullScreen slots={{ transition: Slide }} slotProps={{ transition: { direction: 'up' } }}>
      <DialogContent sx={{ p: 0 }}>
        <MessagingNotice />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setOpen(false)}
          size="large"
        >Next</Button>
      </DialogActions>
    </Dialog>
  );
};
